import type { CSSProperties, ReactNode } from "react";

interface CardProps {
  title?: string;
  children: ReactNode;
  style?: CSSProperties;
  /** Accent color for the left border. Defaults to var(--accent). */
  accentColor?: string;
  hero?: boolean;
}

/**
 * The canonical surface card. White paper feel, hairline border, subtle
 * shadow, soft sentence-case header. No mono caps, no diamond accents.
 */
export function Card({ title, children, style, accentColor, hero }: CardProps) {
  const base: CSSProperties = hero
    ? {
        position: "relative",
        background: "var(--bg-card-hero)",
        border: "1px solid var(--border-subtle)",
        borderRadius: "var(--radius-card)",
        padding: "20px 22px",
        overflow: "hidden",
        boxShadow: "var(--shadow-card)",
      }
    : {
        background: "var(--bg-card)",
        border: "1px solid var(--border-subtle)",
        borderLeft: `2px solid ${accentColor ?? "var(--accent)"}`,
        borderRadius: "var(--radius-card)",
        padding: "18px 20px",
        display: "flex",
        flexDirection: "column",
        gap: 14,
        boxShadow: "var(--shadow-card)",
      };

  return (
    <div style={{ ...base, ...style }}>
      {title ? (
        <h5
          style={{
            margin: 0,
            fontFamily: "var(--font-sans)",
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: "-0.005em",
            color: "var(--text-primary)",
            paddingBottom: 12,
            borderBottom: "1px solid var(--border-subtle)",
          }}
        >
          {title}
        </h5>
      ) : null}
      {children}
    </div>
  );
}
